import type { SxProps, Theme } from "@mui/material/styles";

export const massEditWorkingHoursTextButtonSx: SxProps<Theme> = {
  textTransform: "uppercase",
};

export function getMassEditPricesTextButtonSx(
  isSelectionEmpty: boolean,
): SxProps<Theme> {
  return {
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "transparent",
      boxShadow: "none",
      color: isSelectionEmpty ? undefined : "primary.main",
    },
  };
}
